module.exports = __webpack_public_path__ + "static/media/camino.88ed5aac.svg";